import { NgModule } from '@angular/core';
import { MustMatchDirective } from '../directives/must-match.directive';
import { MustNotMatchDirective } from '../directives/must-not-match.directive';
import { EmailValidatorDirective } from '../directives/email-validator.directive';
import { RegExValidatorDirective } from '../directives/regExp-validator.directive';
import { CoreModule } from './core.Module';
import { UrlValidatorDirective } from '../directives/url-validator.directive';
import { BlockCopyPasteDirective } from '../directives/block-copy-paste.directive';
import { ClickOutsideDirective } from 'ng-click-outside';


@NgModule({
    imports: [
        CoreModule
    ],
    exports: [
        EmailValidatorDirective,
        MustMatchDirective,
        MustNotMatchDirective,
        RegExValidatorDirective,
        UrlValidatorDirective,
        BlockCopyPasteDirective,
        // ClickOutsideDirective
    ],
    declarations: [
        EmailValidatorDirective,
        MustMatchDirective,
        MustNotMatchDirective,
        RegExValidatorDirective,
        UrlValidatorDirective,
        BlockCopyPasteDirective,
        // ClickOutsideDirective
    ],
    providers: [
    ]
})
export class CustomValidatorsModule {

}
